var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84375,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F04438"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84375,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D92D20",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6858 45.0615C32.944 45.2122 33.0732 45.2876 33.2555 45.3266C33.3969 45.357 33.6033 45.357 33.7447 45.3266C33.927 45.2876 34.0561 45.2122 34.3144 45.0615C36.5871 43.7356 42.8334 39.5707 42.8334 33.8442V28.2647C42.8334 27.3319 42.8334 26.8656 42.6809 26.4647C42.5461 26.1105 42.3271 25.7945 42.0428 25.544C41.721 25.2603 41.2843 25.0966 40.4109 24.7691L34.1555 22.4233C33.913 22.3323 33.7917 22.2869 33.6669 22.2688C33.5563 22.2528 33.4439 22.2528 33.3332 22.2688C33.2085 22.2869 33.0872 22.3323 32.8447 22.4233L26.5892 24.7691C25.7158 25.0966 25.2792 25.2603 24.9573 25.544C24.6731 25.7945 24.4541 26.1105 24.3193 26.4647C24.1667 26.8656 24.1667 27.3319 24.1667 28.2647V33.8442C24.1667 39.5707 30.413 43.7356 32.6858 45.0615Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured-icon.668efca316c390640562f60d1ab4f97a.svg";
export { ForwardRef as ReactComponent };